export default {
    "lastName": "LHEPBCDPVN",
    "firstName": "XRMGBV",
    "middleName": "I",
    "planId": "805222",
    "planName": "HUBBELL AE JOIN EMP(805222)     SAVINGS AND INVESTMENT PLAN",
    "address": {
        "cityStateZip": {
            "state": "AL",
            "city": "ALABASTER",
            "zipCode": "35007"
        },
        "country": "UNITED STATES",
        "line1": "4515 PAINTERS MILL ROAD",
        "line2": "4515 PAINTERS MILL ROAD",
        "line3": "",
        "state": "AL",
        "region": "AL",
        "postalCode": "35007",
        "city": "ALABASTER"
    },
    "maritalStatus": "MARRIED",
    "spousalConsent": "YES",
    "beneficiaryArray": [
        {
            "@Type": "BeneficiaryPerson",
            "beneficiaryType": "PERSON",
            "beneficiaryId": 1,
            "disbursement": 100.0,
            "level": "PRIMARY",
            "contactAddress": {
                "cityStateZip": {
                    "state": "NY",
                    "city": "Brooklyn",
                    "zipCode": "10001"
                },
                "country": "UNITED STATES",
                "line1": "ests",
                "line2": "test",
                "line3": "",
                "state": "NY",
                "region": "NY",
                "postalCode": "10001",
                "city": "Brooklyn"
            },
            "comment": "",
            "status": "CURRENT",
            "freeFormCountry": "",
            "deleteChecked": false,
            "relation": "NONSPOUSE",
            "middleName": "",
            "birthDate": "03/11/1991",
            "firstName": "TEST SUNIL",
            "lastName": "S",
            "ssn": "000-00-0000",
            "federalId": "000-00-0000",
            "name": "S, TEST SUNIL",
            "country": "UNITED STATES",
            "region": "NY",
            "postalCode": "10001",
            "line1": "ests",
            "city": "Brooklyn",
            "line2": "test",
        },
        {
            "@Type": "BeneficiaryPerson",
            "beneficiaryType": "PERSON",
            "beneficiaryId": 1,
            "disbursement": 50.0,
            "level": "PRIMARY",
            "contactAddress": {
                "cityStateZip": {
                    "state": "NY",
                    "city": "Brooklyn",
                    "zipCode": "10001"
                },
                "country": "UNITED STATES",
                "line1": "ests",
                "line2": "test",
                "line3": "",
                "state": "NY",
                "region": "NY",
                "postalCode": "10001",
                "city": "Brooklyn"
            },
            "comment": "",
            "status": "CURRENT",
            "freeFormCountry": "",
            "deleteChecked": false,
            "relation": "NONSPOUSE",
            "middleName": "",
            "birthDate": "03/11/1991",
            "firstName": "TEST SUNIL",
            "lastName": "S",
            "ssn": "000-00-0000",
            "federalId": "000-00-0000",
            "name": "S, TEST SUNIL",
            "country": "UNITED STATES",
            "region": "NY",
            "postalCode": "10001",
            "line1": "ests",
            "city": "Brooklyn",
            "line2": "test",
        },
        {
            "@Type": "BeneficiaryPerson",
            "beneficiaryType": "PERSON",
            "beneficiaryId": 1,
            "disbursement": 10.0,
            "level": "SECONDARY",
            "contactAddress": {
                "cityStateZip": {
                    "state": "NY",
                    "city": "Brooklyn",
                    "zipCode": "10001"
                },
                "country": "UNITED STATES",
                "line1": "ests",
                "line2": "test",
                "line3": "",
                "state": "NY",
                "region": "NY",
                "postalCode": "10001",
                "city": "Brooklyn"
            },
            "comment": "",
            "status": "CURRENT",
            "freeFormCountry": "",
            "deleteChecked": false,
            "relation": "NONSPOUSE",
            "middleName": "",
            "birthDate": "03/11/1991",
            "firstName": "TEST SUNIL",
            "lastName": "S",
            "ssn": "000-00-0000",
            "federalId": "000-00-0000",
            "name": "S, TEST SUNIL",
            "country": "UNITED STATES",
            "region": "NY",
            "postalCode": "10001",
            "line1": "ests",
            "city": "Brooklyn",
            "line2": "test",
        }
    ],
    "currentQPSASelection": null,
    "currentMaritalStatus": null,
    "birthDate": "10/12/88",
    "name": "LHEPBCDPVN, XRMGBV I",
    "ssn": "1086"
}
